export default __webpack_public_path__ + "4f9bd6a8b854cb5ad72cc42f72f324fe.png";